/**
 * Generate a Universally Unique Identifier (UUID)
 * @see https: //stackoverflow.com/a/2117523/38375
 * @returns {string} the generated UUID
 */
export function uuidv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function closeOnClickOutside(element: Element, cb: () => void): void {
  document.addEventListener('click', (evt) => {
    if (evt.target !== element && !element.contains(evt.target as Element)) {
      cb()
    }
  })
}
